//# sourceMappingURL=view.mjs.map
/// <reference types="./view.d.mts" />
import * as $project from "../../../../data_types/data/project.mjs";
import * as $project_file from "../../../../data_types/data/project_file.mjs";
import * as $remote from "../../../../data_types/data/remote.mjs";
import * as $language from "../../../../data_types/data/translate/language.mjs";
import * as $label from "../../../../ds/ds/components/label.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $skeleton from "../../../../ds/ds/components/skeleton.mjs";
import * as $table from "../../../../ds/ds/components/table.mjs";
import * as $icons from "../../../../ds/ds/icons.mjs";
import * as $utils from "../../../../ds/ds/utils.mjs";
import * as $dict from "../../../../gleam_stdlib/gleam/dict.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../../gleam_stdlib/gleam/result.mjs";
import * as $mime_types from "../../../../mime_types/mime_types.mjs";
import * as $redraw from "../../../../redraw/redraw.mjs";
import * as $events from "../../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../../redraw_dom/redraw/dom/html.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $length from "../../../../sketch/sketch/css/length.mjs";
import { px } from "../../../../sketch/sketch/css/length.mjs";
import * as $timestamp_ from "../../../../tiamat/gleam/time/timestamp_.mjs";
import * as $project_effects from "../../../admin/effects/project.mjs";
import * as $store from "../../../data/store.mjs";
import { toList } from "../../../gleam.mjs";
import * as $common from "../../../view/common.mjs";

function text(text) {
  return $h.div(toList([]), toList([$h.text(text)]));
}

function project_row(project) {
  return $table.row(
    toList([
      $table.cell(text("")),
      $table.cell(text(project.name)),
      $table.cell(text("")),
      $table.cell(text("")),
      $table.cell(text("")),
      $table.cell(text("")),
      $table.cell(text("")),
      $table.cell(text("")),
    ]),
  );
}

export function mime_icon(mime_type) {
  let _pipe = mime_type;
  let _pipe$1 = $option.map(_pipe, $utils.mime_icon);
  let _pipe$2 = $option.map(_pipe$1, $icons.small);
  return $option.lazy_unwrap(_pipe$2, $h.none);
}

function file_row(file, dispatch_effect) {
  let on_click = (_) => {
    dispatch_effect($project_effects.download_project_file(file));
    return undefined;
  };
  let on_click_converted = (mime_type) => {
    return (_) => {
      dispatch_effect(
        $project_effects.download_converted_project_file(file, mime_type),
      );
      return undefined;
    };
  };
  return $table.row(
    toList([
      $table.cell(text("")),
      $table.cell(text("")),
      $table.cell(
        $l.row(
          toList([$l.gap(12)]),
          toList([$events.on_click(on_click)]),
          toList([mime_icon(file.metadata.mime_type), text(file.name)]),
        ),
      ),
      $table.cell(
        $l.row(
          toList([$l.gap(12), $l.justify("space-between")]),
          toList([]),
          toList([
            $label.label(
              toList([
                $label.content($project_file.status_to_string(file.status)),
              ]),
            ),
            (() => {
              let $ = file.metadata.user_validated_status;
              if ($) {
                return $label.label(
                  toList([$label.content("Validated"), $label.success()]),
                );
              } else {
                return $label.label(
                  toList([$label.content("Not validated"), $label.error()]),
                );
              }
            })(),
          ]),
        ),
      ),
      $table.cell(
        (() => {
          let content = $timestamp_.to_locale_full_date(file.created_at);
          return $l.row(
            toList([]),
            toList([]),
            toList([$label.label(toList([$label.content(content)]))]),
          );
        })(),
      ),
      $table.cell(
        $l.row(
          toList([$l.gap(6)]),
          toList([]),
          (() => {
            let _pipe = file.metadata.converted_urls;
            let _pipe$1 = $dict.keys(_pipe);
            return $list.map(
              _pipe$1,
              (m) => {
                return $h.div(
                  toList([$events.on_click(on_click_converted(m))]),
                  toList([$icons.small($utils.mime_icon(m))]),
                );
              },
            );
          })(),
        ),
      ),
      $table.cell(
        $l.row(
          toList([$l.gap(6)]),
          toList([]),
          (() => {
            let _pipe = file.metadata.exported_urls;
            let _pipe$1 = $dict.keys(_pipe);
            return $list.map(
              _pipe$1,
              (l) => {
                let _pipe$2 = l;
                let _pipe$3 = $language.to_emoji(_pipe$2);
                return $h.text(_pipe$3);
              },
            );
          })(),
        ),
      ),
      $table.cell(
        $l.row(
          toList([$l.gap(6)]),
          toList([]),
          toList([
            (() => {
              let $ = file.metadata.language;
              if ($ instanceof $option.Some) {
                let language = $[0];
                let _pipe = language;
                let _pipe$1 = $language.to_emoji(_pipe);
                return $h.text(_pipe$1);
              } else {
                return $h.none();
              }
            })(),
          ]),
        ),
      ),
    ]),
  );
}

export function view() {
  return $redraw.component_(
    "ProjectFile",
    (_) => {
      let store = $store.use_state();
      let dispatch = $store.use_effect_dispatch();
      let project_files = store.project_files;
      let $ = store.projects;
      if ($ instanceof $remote.NotLoaded) {
        return $skeleton.custom(px(200), px(800));
      } else if ($ instanceof $remote.Loading) {
        return $skeleton.custom(px(200), px(800));
      } else if ($ instanceof $remote.Errored) {
        return $skeleton.custom(px(200), px(800));
      } else {
        let projects = $[0];
        return $l.column(
          toList([$l.gap(12), $l.styles(toList([$css.z_index(8000)]))]),
          toList([]),
          toList([
            $common.page_title("Project Files"),
            $l.row(
              toList([$l.justify("space-between")]),
              toList([]),
              toList([
                $table.table(
                  toList([]),
                  toList([
                    $table.headers(
                      toList([
                        (() => {
                          let _pipe = $table.header("");
                          return $table.fit(_pipe);
                        })(),
                        (() => {
                          let _pipe = $table.header("Project");
                          return $table.clamp(_pipe, "250px", 300);
                        })(),
                        (() => {
                          let _pipe = $table.header("Name");
                          return $table.clamp(_pipe, "250px", 300);
                        })(),
                        (() => {
                          let _pipe = $table.header("Status");
                          return $table.fit(_pipe);
                        })(),
                        (() => {
                          let _pipe = $table.header("Created at");
                          return $table.clamp(_pipe, "250px", 300);
                        })(),
                        (() => {
                          let _pipe = $table.header("Converted formats");
                          return $table.clamp(_pipe, "250px", 300);
                        })(),
                        (() => {
                          let _pipe = $table.header("Exports");
                          return $table.clamp(_pipe, "250px", 300);
                        })(),
                        (() => {
                          let _pipe = $table.header("Language");
                          return $table.clamp(_pipe, "250px", 300);
                        })(),
                      ]),
                    ),
                    $table.body(
                      $list.flat_map(
                        projects.elements,
                        (project) => {
                          let _pipe = project_files;
                          let _pipe$1 = $dict.get(_pipe, project.id);
                          let _pipe$2 = $result.unwrap(_pipe$1, toList([]));
                          let _pipe$3 = $list.map(
                            _pipe$2,
                            (_capture) => {
                              return file_row(_capture, dispatch);
                            },
                          );
                          return $list.prepend(_pipe$3, project_row(project));
                        },
                      ),
                    ),
                  ]),
                ),
              ]),
            ),
          ]),
        );
      }
    },
  );
}
